import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { MapPinOff } from 'lucide-react';

interface LocationPermissionDialogProps {
  open: boolean;
  onRetry: () => void;
  onCancel: () => void;
  isStrictMode: boolean;
}

export const LocationPermissionDialog = ({
  open,
  onRetry,
  onCancel,
  isStrictMode,
}: LocationPermissionDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={(open) => !open && onCancel()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <MapPinOff className="h-5 w-5 text-destructive" />
            Location Permission Required
          </AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <p>
              Location access is {isStrictMode ? 'required' : 'needed'} to clock {isStrictMode ? 'in or out' : 'in/out'}.
            </p>
            <p className="text-sm">
              Please enable location permissions in your browser settings and try again.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          {!isStrictMode && (
            <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          )}
          <AlertDialogAction onClick={onRetry}>
            Retry
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
